import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@pc-ui/button';
import { ErrorModule } from '@pc-ui/error/error.module';
import { IconModule } from '@pc-ui/icon';
import { LabelModule } from '@pc-ui/label/label.module';
import { InputComponent } from './input.component';

@NgModule({
  declarations: [InputComponent],
  imports: [
    CommonModule,
    ErrorModule,
    ReactiveFormsModule,
    FormsModule,
    IconModule,
    LabelModule,
    ButtonModule,
  ],
  exports: [InputComponent],
})
export class InputModule {}
